import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// /home/ubuntu/avaai_dashboard/frontend/src/pages/Subscribe.tsx
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
const API_BASE = "";
function PaymentBadge() {
    return (_jsxs("div", { style: styles.stripeWrap, children: [_jsx("svg", { width: "18", height: "18", viewBox: "0 0 32 32", "aria-hidden": "true", children: _jsx("rect", { x: "2", y: "2", width: "28", height: "28", rx: "8", fill: "#635BFF" }) }), _jsx("span", { style: styles.stripeText, children: "Apple In-App Purchase" })] }));
}
export default function Subscribe() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    useEffect(() => {
        const stored = localStorage.getItem("ava_user");
        if (!stored)
            return;
        try {
            const parsed = JSON.parse(stored);
            if (parsed?.email)
                setEmail(parsed.email);
        }
        catch {
            // ignore malformed local storage
        }
    }, []);
    useEffect(() => {
        const reset = () => {
            setLoading(false);
            setMessage("");
        };
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible")
                reset();
        };
        reset();
        window.addEventListener("pageshow", reset);
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            window.removeEventListener("pageshow", reset);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);
    async function handleSubscribe() {
        setMessage("AVAAIO paid plans are not available before the official release.");
    }
    function goBack() {
        window.location.href = "/login";
    }
    return (_jsxs("div", { style: styles.page, children: [_jsx("div", { style: styles.bgGlowTop }), _jsx("div", { style: styles.bgGlowBottom }), _jsxs("div", { style: styles.card, children: [_jsx("div", { style: styles.brandLine, children: "AVAAIO\u2122" }), _jsx("h1", { style: styles.title, children: "Pro Plans Coming Soon" }), _jsxs("p", { style: styles.subtitle, children: ["Every approved account remains on the AVAAIO Standard plan during preview.", _jsx("br", {}), "Paid subscriptions will open at release."] }), _jsx("div", { style: styles.inputWrap, children: _jsx("input", { value: email, readOnly: true, disabled: true, placeholder: "Your account email is used automatically after login" }) }), _jsx("button", { onClick: handleSubscribe, style: {
                            ...styles.button,
                            ...(loading ? styles.buttonDisabled : {}),
                        }, disabled: true, children: "Pro Plans Available at Release" }), _jsxs("div", { style: styles.footer, children: [_jsx(PaymentBadge, {}), _jsx("button", { onClick: goBack, style: styles.backButton, children: "\u2190 Continue with Free / Back to Login" })] }), message ? _jsx("p", { style: styles.error, children: message }) : null, _jsxs("div", { style: styles.legalFooter, children: [_jsx("div", { style: styles.legalPowered, children: "Ava is powered by AVAAIO\u2122" }), _jsx("div", { style: styles.legalTech, children: "Built on American Global\u2122 AI Technology" }), _jsx("div", { style: styles.legalCopy, children: "\u00A9 2026 American Globalo, LLC. All rights reserved." }), _jsx("div", { style: styles.legalTrademark, children: "AVAAIO\u2122 is a trademark of American Globalo, LLC." }), _jsxs("div", { style: styles.legalLinks, children: [_jsx(Link, { to: "/privacy-policy", style: styles.legalLink, children: "Privacy Policy" }), _jsx("span", { style: styles.legalSeparator, children: " | " }), _jsx(Link, { to: "/terms-and-conditions", style: styles.legalLink, children: "Terms & Conditions" }), _jsx("span", { style: styles.legalSeparator, children: " | " }), _jsx(Link, { to: "/ai-disclaimer", style: styles.legalLink, children: "AI Disclaimer" })] })] })] })] }));
}
const styles = {
    page: {
        minHeight: "100vh",
        width: "100%",
        position: "relative",
        overflow: "hidden",
        background: "radial-gradient(circle at top center, rgba(0,220,255,0.08), transparent 24%), linear-gradient(180deg, #00050d 0%, #000814 45%, #00030a 100%)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "clamp(18px, 3vw, 32px)",
        boxSizing: "border-box",
        fontFamily: 'Inter, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },
    bgGlowTop: {
        position: "absolute",
        top: "-10%",
        left: "50%",
        transform: "translateX(-50%)",
        width: "min(66vw, 760px)",
        height: "min(66vw, 760px)",
        borderRadius: "50%",
        background: "radial-gradient(circle, rgba(0,220,255,0.12) 0%, rgba(0,220,255,0.04) 36%, transparent 72%)",
        filter: "blur(28px)",
        pointerEvents: "none",
    },
    bgGlowBottom: {
        position: "absolute",
        bottom: "-18%",
        left: "50%",
        transform: "translateX(-50%)",
        width: "min(58vw, 640px)",
        height: "min(58vw, 640px)",
        borderRadius: "50%",
        background: "radial-gradient(circle, rgba(0,100,220,0.08) 0%, rgba(0,100,220,0.02) 40%, transparent 72%)",
        filter: "blur(28px)",
        pointerEvents: "none",
    },
    card: {
        position: "relative",
        zIndex: 1,
        width: "min(100%, 520px)",
        borderRadius: "24px",
        border: "1px solid rgba(35, 211, 238, 0.28)",
        background: "linear-gradient(180deg, rgba(8,16,28,0.94) 0%, rgba(4,9,18,0.97) 100%)",
        boxShadow: "0 0 0 1px rgba(255,255,255,0.03), 0 0 34px rgba(0,220,255,0.10), 0 22px 80px rgba(0,0,0,0.46)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        padding: "30px 24px 22px",
        boxSizing: "border-box",
        textAlign: "center",
    },
    brandLine: {
        textAlign: "center",
        fontSize: "0.88rem",
        letterSpacing: "0.32em",
        textTransform: "uppercase",
        color: "#7cf8ff",
        marginBottom: "12px",
        fontWeight: 800,
        fontFamily: '"Orbitron", Inter, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        textShadow: "0 0 12px rgba(0,255,255,0.22)",
    },
    title: {
        margin: "0 0 10px",
        fontSize: "clamp(2rem, 4vw, 2.7rem)",
        lineHeight: 1.08,
        color: "#efffff",
        fontWeight: 900,
        letterSpacing: "-0.02em",
        fontFamily: '"Orbitron", Inter, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        textShadow: "0 0 20px rgba(0,220,255,0.12)",
    },
    subtitle: {
        margin: "0 0 24px",
        fontSize: "0.98rem",
        lineHeight: 1.6,
        color: "rgba(215, 240, 245, 0.82)",
        fontWeight: 500,
    },
    inputWrap: {
        marginBottom: "14px",
    },
    input: {
        width: "100%",
        minHeight: "54px",
        padding: "0 16px",
        borderRadius: "16px",
        border: "1px solid rgba(90, 215, 255, 0.22)",
        background: "rgba(6, 14, 24, 0.92)",
        color: "#f3ffff",
        boxSizing: "border-box",
        outline: "none",
        fontSize: "0.98rem",
        fontWeight: 500,
        letterSpacing: "0.01em",
        boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.02)",
    },
    button: {
        width: "100%",
        minHeight: "54px",
        borderRadius: "16px",
        border: "none",
        background: "linear-gradient(90deg, #00d8ff 0%, #00ffee 55%, #7ffcff 100%)",
        color: "#04131a",
        fontSize: "1rem",
        fontWeight: 900,
        letterSpacing: "0.04em",
        cursor: "pointer",
        boxShadow: "0 0 18px rgba(0,255,255,0.18), 0 10px 26px rgba(0,0,0,0.22)",
    },
    buttonDisabled: {
        opacity: 0.62,
        cursor: "not-allowed",
        boxShadow: "none",
    },
    footer: {
        marginTop: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px",
    },
    stripeWrap: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontSize: "12px",
        color: "#94a3b8",
        fontWeight: 600,
    },
    stripeText: {
        fontSize: "12px",
        letterSpacing: "0.02em",
    },
    backButton: {
        width: "100%",
        minHeight: "48px",
        marginTop: "2px",
        borderRadius: "14px",
        border: "1px solid rgba(100, 220, 255, 0.20)",
        background: "rgba(10, 18, 30, 0.84)",
        color: "#b8fbff",
        fontSize: "0.95rem",
        fontWeight: 700,
        letterSpacing: "0.01em",
        cursor: "pointer",
    },
    error: {
        marginTop: "14px",
        color: "#ff9a9a",
        fontSize: "0.9rem",
        lineHeight: 1.5,
        fontWeight: 600,
    },
    legalFooter: {
        marginTop: "18px",
        textAlign: "center",
        fontSize: "0.72rem",
        lineHeight: 1.5,
        color: "rgba(210,240,245,0.72)",
    },
    legalPowered: {
        marginBottom: "4px",
        fontWeight: 600,
    },
    legalTech: {
        fontSize: "11px",
        color: "rgba(255,255,255,0.72)",
        marginTop: "6px",
    },
    legalTrademark: {
        fontSize: "10px",
        color: "rgba(255,255,255,0.58)",
        marginTop: "4px",
    },
    legalCopy: {
        marginBottom: "6px",
    },
    legalLinks: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
    },
    legalLink: {
        color: "rgba(154,252,255,0.92)",
        textDecoration: "none",
        fontWeight: 700,
    },
    legalSeparator: {
        color: "rgba(154,252,255,0.42)",
        padding: "0 6px",
    },
};
